import * as React from 'react';

import { Form, Input, Select } from 'antd';

import FilterPanel from 'v2/components/Shared/FilterPanel';
import { WebhookStatus } from 'v2/interfaces/webhook2';

import { Icon } from '@eduzz/ui-antd-theme';

import { useWebhookContext } from '../context';

function Filter() {
  const { filter, setFilter, webhooks } = useWebhookContext();

  const handleChangeField = (name: string, value: string) => {
    setFilter({ ...filter, [name]: value });
  };

  const hasWebhooks = webhooks?.length > 0;

  return (
    <FilterPanel id='webhook-filters'>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-12'>
        <Form.Item label='URL/Nome' className='mb-0 md:col-span-6'>
          <Input
            placeholder='Pesquise por URL ou nome'
            id='url_webhook'
            allowClear
            suffix={<Icon.Funnel size={16} />}
            onChange={e => handleChangeField('url', e.target.value)}
            disabled={!hasWebhooks}
          />
        </Form.Item>

        <Form.Item label='Status' className='mb-0 md:col-span-3'>
          <Select
            id='status'
            className='w-full'
            value={filter.status}
            onChange={value => handleChangeField('status', value)}
            disabled={!hasWebhooks}
            options={[
              { label: 'Todos', value: 'all' },
              { label: 'Ativo', value: `${WebhookStatus.active.toString()}` },
              { label: 'Inativo', value: `${WebhookStatus.inactive.toString()}` },
              { label: 'Com erro', value: `${WebhookStatus.failing.toString()}` }
            ]}
          />
        </Form.Item>

        <Form.Item label='Tipo' className='mb-0 md:col-span-3'>
          <Select
            id='type'
            className='w-full'
            value={filter.type}
            onChange={value => handleChangeField('type', value)}
            disabled={!hasWebhooks}
            options={[
              { label: 'Todos', value: 'all' },
              { label: 'Fatura', value: 'invoice' },
              { label: 'Abandono de Carrinho', value: 'abandonment' }
            ]}
          />
        </Form.Item>
      </div>
    </FilterPanel>
  );
}

export { Filter };
